export const environment = {
  production: false,
  title: 'Testing Environment',
};
